var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiologyDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 64,
    rx: 16,
    fill: "#DEFAF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4430_18989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.662 47.999C29.0915 47.999 26.5209 47.999 23.9504 47.999C23.029 47.999 22.5526 47.5083 22.5507 46.5541C22.5477 44.9517 22.5106 43.3484 22.5673 41.749C22.5869 41.2058 22.8255 40.6646 23.0036 40.1376C23.0906 39.8801 23.0583 39.7347 22.8607 39.5509C15.5776 32.7497 17.9671 20.2679 27.2095 16.8209C34.7754 13.9988 42.9927 18.7201 44.5382 26.8884C45.4752 31.841 44.0687 36.1018 40.4623 39.5479C40.2735 39.7276 40.1982 39.871 40.3146 40.1264C40.7166 41.013 40.8379 41.9439 40.7997 42.9243C40.7528 44.1531 40.7899 45.3849 40.788 46.6147C40.786 47.4931 40.2999 47.997 39.4479 47.998C36.853 48 34.257 47.998 31.662 47.998V47.999ZM39.354 37.2478C43.4319 33.0354 43.5933 25.7849 38.9168 21.3473C34.3431 17.0077 27.0706 17.6448 23.2344 22.7386C19.4881 27.7134 20.8223 34.1653 24.055 37.2064C24.5686 35.702 25.0811 34.2097 25.58 32.7133C25.6142 32.6114 25.5741 32.4639 25.5291 32.3559C25.0606 31.2281 24.8728 30.0599 24.9755 28.8321C25.3139 24.7792 29.1472 21.8279 33.003 22.6669C37.3186 23.606 39.6054 28.195 37.8467 32.3781C37.7988 32.4912 37.7841 32.6507 37.8203 32.7658C37.9768 33.2646 38.1597 33.7543 38.329 34.2481C38.6664 35.2325 39.0019 36.218 39.3531 37.2478H39.354ZM37.9377 40.601C37.9181 40.5222 37.9064 40.4607 37.8868 40.4021C37.1268 38.1293 36.3629 35.8575 35.6088 33.5837C35.5012 33.2586 35.2909 33.1697 34.9828 33.1707C32.7976 33.1768 30.6134 33.1798 28.4283 33.1687C28.0576 33.1667 27.8727 33.3101 27.7544 33.6715C27.098 35.6697 26.4221 37.6618 25.7541 39.6559C25.6504 39.9649 25.5536 40.2759 25.4489 40.602H37.9387L37.9377 40.601ZM35.8337 30.8121C36.3942 29.5066 35.9971 27.2691 34.3724 25.9747C32.7741 24.7025 30.5371 24.7196 28.9575 26.0252C27.3533 27.3519 27.0139 29.5752 27.5636 30.8121H35.8337ZM24.953 45.5131H38.4287V43.101H24.953V45.5131Z",
    fill: "#27D9A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4430_18989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiologyDefault);
export default __webpack_public_path__ + "static/media/radiology-default.906a398b7f4b03db5efe189f000a2493.svg";
export { ForwardRef as ReactComponent };